import { Link, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { q } from '../../api/queries';
import { Pager } from '../../components/pager';
import { Empty, Mono, Page, PageHeader, Panel, Skeleton, Table, col } from '@bounded/ui/primitives';
import { ErrorNotice } from '@bounded/ui/state';
import { useFormat, useT } from '../../i18n';
import { AccountStatus } from './accounts.$accountId';

export const Route = createFileRoute('/_app/accounts/')({
  validateSearch: (search): { after?: string } => ({ after: typeof search.after === 'string' && search.after ? search.after : undefined }),
  component: Accounts,
});

function Accounts() {
  const t = useT(); const m = t.accounts; const f = useFormat();
  const { after } = Route.useSearch();
  const accounts = useQuery(q.accounts(after));
  const items = accounts.data?.items ?? [];
  return (
    <Page>
      <PageHeader title={m.title} description={m.description} />
      {accounts.error ? <ErrorNotice error={accounts.error} onRetry={() => void accounts.refetch()} /> : (
        <Panel>
          {!accounts.data ? <div className="p-4"><Skeleton className="h-40" /></div> : !items.length ? <Empty title={m.empty} /> : (
            <Table head={[{ label: t.labels.name }, { label: t.labels.id, className: col.hideSm }, { label: t.labels.created, className: col.hideMd }, { label: t.labels.status, className: col.action }]}>
              {items.map((a) => (
                <tr key={a.id}>
                  <td><Link to="/accounts/$accountId" params={{ accountId: a.id }} className="font-medium hover:underline">{a.name}</Link></td>
                  <td className={col.hideSm}><Mono value={a.id} /></td>
                  <td className={`${col.hideMd} text-graphite`}>{f.dateTime(a.created_at)}</td>
                  <td className={col.action}><AccountStatus status={a.status} /></td>
                </tr>
              ))}
            </Table>
          )}
        </Panel>
      )}
      {accounts.data && <Pager to="/accounts" after={after} items={items} />}
    </Page>
  );
}
